module.exports = __webpack_public_path__ + "static/media/githubblack.16614d5c.png";